import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectTransferType } from './transferTypesSlice';

export default function TransferTypeSelect() {
  const { transferTypes, selected } = useSelector((state) => state.transferTypes);
  // const { countryCode } = useSelector((state) => state.receiver);
  const selectedNetwork = useSelector((state) => state.networks.selected);
  const dispatch = useDispatch();

  const handleTransferTypeChange = (type) => {
    dispatch(selectTransferType(type));
  };

  let disabled = false;

  return (
    <div className="transfer-type-picker-wrapper">
      <div className="transfer-type-picker">
        {transferTypes.map((t) => {
          let className = 'transfer-type non-selectable';

          if (t.type === selected) {
            className += ' active';
          }

          // if (t.type === 2 && countryCode !== 'NG') {
          //   className += ' disabled';
          //   disabled = true;
          // }

          if (t.type === 2 && selectedNetwork.dataPackets.length === 0) {
            className += ' disabled';
            disabled = true;
          }

          return (
            <div
              className={className}
              key={t.type}
              onClick={() => !disabled && handleTransferTypeChange(t.type)}
            >
              {t.name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
